import { Network } from 'turbos-clmm-sdk';
import production, { type Config } from './mainnet';

const staging: Config = {
  ...production,
  sui_network: Network.testnet,
  deepbook_env: 'testnet',
  api_url: 'https://api.turbos.finance/testnet/',
  explorer_url: {
    suiscan: {
      txb: 'https://suiscan.xyz/testnet/tx/{{txb}}',
      account: 'https://suiscan.xyz/testnet/account/{{account}}',
      object: 'https://suiscan.xyz/testnet/object/{{object}}',
      coin: 'https://suiscan.xyz/testnet/coin/{{coin}}',
    },
    suivision: {
      txb: 'https://testnet.suivision.xyz/txblock/{{txb}}',
      account: 'https://testnet.suivision.xyz/account/{{account}}',
      object: 'https://testnet.suivision.xyz/object/{{object}}',
      coin: 'https://testnet.suivision.xyz/coin/{{coin}}',
    },
    sui_explorer: {
      txb: 'https://suiexplorer.com/txblock/{{txb}}?network=testnet',
      account: 'https://suiexplorer.com/address/{{account}}?network=testnet',
      object: 'https://suiexplorer.com/object/{{object}}?network=testnet',
      coin: 'https://suiexplorer.com/object/{{coin}}?network=testnet',
    },
  },
  fullnode: 'https://fullnode.testnet.sui.io:443',
  deepbook_package_id: '0x2c152dba0110d3afb76b659ed3436edd848b37e177c3abfc0296f8aefc2e6cf4',
  deepbook_pools: [
    {
      poolKey: 'DEEP_SUI',
      address: `0x2decc59a6f05c5800e5c8a1135f9d133d1746f562bf56673e6e81ef4f7ccd3b7`,
      baseCoin: 'DEEP',
      quoteCoin: 'SUI',
    },
    {
      poolKey: 'SUI_DBUSDC',
      address: `0xace543e8239f0c19783e57bacb02c581fd38d52899bdce117e49c91b494c8b10`,
      baseCoin: 'SUI',
      quoteCoin: 'DBUSDC',
    },
    {
      poolKey: 'DEEP_DBUSDC',
      address: `0x1faaa544a84c16215ef005edb046ddf8e1cfec0792aec3032e86e554b33bd33a`,
      baseCoin: 'DEEP',
      quoteCoin: 'DBUSDC',
    },
    {
      poolKey: 'DBUSDT_DBUSDC',
      address: `0x83aca040eaeaf061e3d482a44d1a87a5b8b6206ad52edae9d0479b830a38106f`,
      baseCoin: 'DBUSDT',
      quoteCoin: 'DBUSDC',
    },
  ],
  deepbook_coins: [
    {
      type: '0x36dbef866a1d62bf7328989a10fb2f07d769f4ee587c0de4a0a256e57e0a58a8::deep::DEEP',
      symbol: 'DEEP',
      decimals: 6,
    },
    {
      type: '0x2::sui::SUI',
      symbol: 'SUI',
      decimals: 9,
    },
    {
      type: '0xf7152c05930480cd740d7311b5b8b45c6f488e3a53a11c3f74a6fac36a52e0d7::DBUSDC::DBUSDC',
      symbol: 'DBUSDC',
      decimals: 6,
    },
    {
      type: `0xf7152c05930480cd740d7311b5b8b45c6f488e3a53a11c3f74a6fac36a52e0d7::DBUSDT::DBUSDT`,
      symbol: 'DBUSDT',
      decimals: 6,
    },
  ],
};

export default staging;
